import * as React from 'react';

import { ProjectsPageTabContext } from './types';

export default React.createContext<ProjectsPageTabContext>({
  scrollParent: null,
});
